module.exports = __webpack_public_path__ + "img/hk_room_floorplan_01_en.6fe2189d.png";